import { render } from "./descriptionIcon.vue?vue&type=template&id=76db34c6"
import script from "./descriptionIcon.vue?vue&type=script&lang=js"
export * from "./descriptionIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__